/**
 * as markdown docs cannot use angular components,
 * this is a tiny ad-hoc processor allowing to generate simple accordion sections based on detected headlines.
 */
export var AccordionHelper;
(function (AccordionHelper) {
  let cssClasses;
  (function (cssClasses) {
    cssClasses["Toggle"] = "section-toggle";
    cssClasses["Section"] = "section-collapsible";
    cssClasses["Collapsed"] = "collapsed";
    cssClasses["Expanded"] = "expanded";
  })(cssClasses = AccordionHelper.cssClasses || (AccordionHelper.cssClasses = {}));
  function buildSections(contentWrapper, headlineLevelToFold = 3) {
    const acceptedTags = Array.apply(null, Array(headlineLevelToFold)).map((el, i) => {
      return 'h' + (i + 1);
    });
    function shouldMoveElementIntoSection(input) {
      if (!input) return false;
      if (!input['tagName']) return true; // el is no HTMLElement but text node / comment
      const el = input;
      if (/h[1-6]/.exec(el.tagName.toLowerCase())) {
        const level = parseInt(el.tagName.charAt(1), 10);
        if (level <= headlineLevelToFold) {
          return false;
        }
        return true;
      }
      return true;
    }
    function findNextSiblingHeadline(el) {
      let curr = el.nextSibling;
      while (curr) {
        const tagName = curr['tagName'] && curr.tagName.toLowerCase();
        if (tagName) {
          const isHeadlineElement = acceptedTags.includes(tagName);
          if (isHeadlineElement) {
            return curr;
          }
        }
        curr = curr.nextSibling;
      }
      return null;
    }
    let currLevel;
    let currElement = contentWrapper.firstElementChild;
    let currHeadline = currElement;
    let currContentContainer = null;
    // this iterator is a bit tricky.
    // we know that markdown-based html is not nested, so all headlines are immediate children of contentWrapper.
    // so we iterate children of it until we find a headline. 
    // if the headline is of the level that should be collapsed, we create a container div after the headline.
    // then we started a second loop iterating ALL children, moving them to the container, until we find a headline that is of same or lower level.
    while (currHeadline) {
      currElement = currHeadline;
      currLevel = parseInt(currHeadline.tagName.charAt(1), 10);
      if (headlineLevelToFold === currLevel) {
        // start new section
        const newSection = window.document.createElement('div');
        newSection.classList.add(cssClasses.Section);
        newSection.classList.add(cssClasses.Collapsed);
        // mark headline as toggle
        currHeadline.classList.add(cssClasses.Toggle);
        // store original node that is right after headline
        let currSibling = currHeadline.nextSibling;
        // insert section between headline and the original nextSibling
        currHeadline.parentElement.insertBefore(newSection, currSibling);
        while (shouldMoveElementIntoSection(currSibling)) {
          const tmp = currSibling;
          currSibling = currSibling.nextSibling;
          newSection.appendChild(tmp);
        }
        currElement = newSection;
      }
      currHeadline = findNextSiblingHeadline(currElement);
    }
  }
  AccordionHelper.buildSections = buildSections;
  function toggleSection(headlineOrSection, forceStatus = null) {
    if (!headlineOrSection) return;
    const section = headlineOrSection.classList.contains(cssClasses.Toggle) ? headlineOrSection.nextElementSibling : headlineOrSection;
    if (section) {
      const cl = section.classList;
      const execCollapse = () => {
        cl.add(cssClasses.Collapsed);
        cl.remove(cssClasses.Expanded);
      };
      const execExpand = () => {
        cl.remove(cssClasses.Collapsed);
        cl.add(cssClasses.Expanded);
      };
      if (forceStatus === true) execExpand();else if (forceStatus === false) execCollapse();else if (cl.contains(cssClasses.Collapsed)) execExpand();else execCollapse();
    }
  }
  AccordionHelper.toggleSection = toggleSection;
})(AccordionHelper || (AccordionHelper = {}));